<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path d="m2.5 8.5 3.667 4 7.333-8" fill="none" stroke="#3498db" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"/>
  </svg>
</template>
